import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { MediaObserverService } from '@innogy/shared/responsive-tools';

import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { CommonUiCommonRenderingsModule } from '@legacy/common-ui-common-renderings';
import {
  ExperienceEditorComponent,
  ExperienceEditorLiveDirective,
  ExperienceEditorPreviewDirective,
} from '@core/experience-editor-components';
import {
  BackgroundDirective,
  SkeletonLoadingCardComponent,
  SkeletonLoadingRowComponent,
} from '@legacy/common-ui-shared';
import {
  ButtonComponent,
  StructuredContentComponent,
} from '@legacy/common-ui-partials';
import { TrackLinkDirective } from '@analytics/events';

import { RowContainerComponent } from './row-container/row-container.component';
import { Colset444Component } from './colset444/colset444.component';
import { Colset12Component } from './colset12/colset12.component';
import { Colset66Component } from './colset66/colset66.component';
import { Colset3333Component } from './colset3333/colset3333.component';
import { Colset336Component } from './colset336/colset336.component';
import { Colset48Component } from './colset48/colset48.component';
import { Colset39Component } from './colset39/colset39.component';
import { RowContainerSoloComponent } from './row-container-solo/row-container-solo.component';
import { ColsetMijn363Component } from './colset-mijn-363/colset-mijn-363.component';
import { ColsetMijn39Component } from './colset-mijn-39/colset-mijn-39.component';
import { DynamicRowComponent } from './dynamic-row/dynamic-row.component';

@NgModule({
  imports: [
    CommonModule,
    CommonUiCommonRenderingsModule,
    CommonUiUtilityComponentsModule,
    TranslatePipe,
    TranslateDirective,
    JssModule,
    ExperienceEditorComponent,
    ExperienceEditorLiveDirective,
    SkeletonLoadingCardComponent,
    ExperienceEditorPreviewDirective,
    SkeletonLoadingRowComponent,
    StructuredContentComponent,
    BackgroundDirective,
    ButtonComponent,
    TrackLinkDirective,
    RowContainerComponent,
    Colset444Component,
    Colset12Component,
    Colset66Component,
    Colset3333Component,
    Colset336Component,
    Colset48Component,
    Colset39Component,
    RowContainerSoloComponent,
    ColsetMijn363Component,
    ColsetMijn39Component,
    DynamicRowComponent,
  ],
  providers: [MediaObserverService],
  exports: [
    RowContainerComponent,
    Colset444Component,
    Colset12Component,
    Colset66Component,
    Colset3333Component,
    Colset336Component,
    Colset48Component,
    Colset39Component,
    RowContainerSoloComponent,
    ColsetMijn363Component,
    ColsetMijn39Component,
    DynamicRowComponent,
  ],
})
export class CommonUiGridsModule {}
